import { get, post } from './request'

/**
 * 
 * @param {String} mobile 
 * @param {String} name 
 * @param {String} country_code 
 * @param {String} email 
 * @returns {Promise<
 *  { 
 *      country_code: String
 *      email: String
 *      mobile: String
 *      name: String
 *      wechat_id: String
 * }>}
 */
export function joinUser(form) {
    return post('/api/signUpUser',form )
}

/**
 * 选择国家或地区
 */
 export function getCountries({ page = 1, pageSize = 999, keywords = null, country_code = null }) {
    return get('/api/dict/countries', { page, pageSize, keywords, country_code })
}

/**
 * 点击记录
 * @param {*} type 1 进入首页  2 注册成功  3 订单页
 * @param {*} user_sn 用户sn
 */
export function recordClick(type, user_sn, value) {
    return post('/api/addCheckPointsLog', { type, user_sn,value })
}
/**
 * 获取销售卡片信息
 */
 export function getSaleInfo(invite_code) {
    return get('/api/getSaleInfo?invite_code='+invite_code)
}
/**
 * 获取图片验证码
 */
 export function getImgCode() {
    return get('/api/getImgCode')
}


// WEBPACK FOOTER //
// ./src/api/index.js